import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

const Icons = styled.ul`
    list-style: none;
    text-align: center;
    cursor: default;
    margin: 0 !important;
    li {
        display: inline-block;
        padding: 1.25em;
        margin: 0;
    }
`
const Icon = styled.a`
    font-family: FontAwesome;
    font-size: 1.25em;
    text-decoration: none;
    border-bottom: none !important;
    > .label {
        display: none;
    }
`

export { Icon, Icons } 


// WEBPACK FOOTER //
// ./src/components/icon.js